import React from 'react';

// 說話者顏色對應表
const SPEAKER_COLORS = {
  A: { border: 'border-blue-400',   badge: 'bg-blue-200 text-blue-800' },
  B: { border: 'border-green-400',  badge: 'bg-green-200 text-green-800' },
  C: { border: 'border-amber-400',  badge: 'bg-amber-200 text-amber-800' },
  D: { border: 'border-purple-400', badge: 'bg-purple-200 text-purple-800' },
  E: { border: 'border-rose-400',   badge: 'bg-rose-200 text-rose-800' },
  F: { border: 'border-teal-400',   badge: 'bg-teal-200 text-teal-800' },
};

function getSpeakerColor(speaker) {
  if (!speaker) return null;
  const letter = speaker.slice(-1);
  return SPEAKER_COLORS[letter] || SPEAKER_COLORS.A;
}

export default function TranscriptCard({ fileResult }) {
  const { file_name, segments } = fileResult;
  // 把所有段落文字串接，若有 speaker 則加前綴
  const fullText = segments.map((s) => {
    const prefix = s.speaker ? `[${s.speaker}] ` : '';
    return `${prefix}${s.text}`;
  }).join(' ');

  return (
    <div className="mt-6 bg-white p-6 rounded-xl shadow-lg">
      <h2 className="text-2xl font-semibold mb-4">{file_name}</h2>

      {/* 這裡改為 whitespace-normal，全文就由瀏覽器自動排版 */}
      <div className="whitespace-normal text-gray-800 mb-6">{fullText}</div>

      <div className="space-y-4 max-h-96 overflow-y-auto">
        {segments.map((seg, index) => {
          const spkColor = getSpeakerColor(seg.speaker);
          const borderClass = spkColor ? spkColor.border : 'border-blue-400';
          return (
            <div
              key={seg.id ?? index}
              className={`p-4 bg-gray-50 rounded-md border-l-4 ${borderClass}`}
            >
              <div className="text-xs text-gray-500 mb-1 flex items-center space-x-2">
                <span>段落 {(seg.id ?? index) + 1} ｜ {(seg.start ?? 0).toFixed(1)}s – {(seg.end ?? 0).toFixed(1)}s</span>
                {seg.speaker && spkColor && (
                  <span className={`text-xs px-1.5 py-0.5 rounded-full ${spkColor.badge}`}>
                    {seg.speaker}
                  </span>
                )}
              </div>
              <div className="text-gray-700">{seg.text}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
